import styled from 'styled-components'

export const FormDiv = styled.div`
  display: flex;
  width: 100%;
`

export const SubTitle = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  text-align: left;
  line-height: 26px;
  margin-left: 10px;
  margin-bottom: 10px;
`

export const CardsWrap = styled.div`
  display: flex;
  position: absolute;
  flex-direction: row;
  max-height: 55%;
  flex-wrap: wrap;
  max-width: 75%;
  overflow-y: scroll;
  padding: 10px 0 0 10px;
  gap: 20px;

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-track {
    background: white;
    border: 0;
  }
  ::-webkit-scrollbar-thumb {
    width: 8px;
    background-color: #c4c4c4;
    border-radius: 50px;
    height: 140px;
  }
  .row {
    display: flex;
    gap: 20px;
    width: 100%;
  }
`
export const Wrapper = styled.div`
  display: flex;
  /* position: absolute; */
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 90%;
  overflow: hidden;

  .content-wrapper {
    height: 100%;
    overflow: hidden;
    margin-left: 10px;
  }

  .align-self {
    /* position: absolute; */
    /* bottom: 50px; */
    width: 100%;
    z-index: 220;
    /* border: 1px solid red; */
  }
`
